import { logError } from "common/error";
import { onlyOnce } from "common/functions";
import { load } from "common/loader";
import { Waiter } from "common/promises";
import * as FromStartSkipper from "from-start/skipper";
import log from "loglevel";
import { toRootPath } from "../resources";
const interactionMovieNames = [
    "1번 영상.mp4",
    "2번 영상.mp4",
    "3번 영상.mp4",
    "5번 영상.mp4",
    "6번 영상.mp4",
    "7번 영상.mp4",
];
/**
 * 인터렉션 사이사이 비디오를 로딩한다.
 * loadStart를 호출하면 모든 영상을 순차적으로 로딩한다.
 * 영상을 불러올 준비가 되었을 때
 */
export class InteractionVideoLoader {
    constructor() {
        this.loadStatus = {
            "1번 영상.mp4": false,
            "2번 영상.mp4": false,
            "3번 영상.mp4": false,
            "5번 영상.mp4": false,
            "6번 영상.mp4": false,
            "7번 영상.mp4": false,
        };
        this.callbacks = emptyCallbacks();
        this.waiters = newWaiters();
        this.loadStart = this.loadStart.bind(this);
        this.loadStart = onlyOnce(this.loadStart);
    }
    loadStart() {
        this._loadLoop().catch(logError);
    }
    async _loadLoop() {
        for (const fileName of interactionMovieNames) {
            log.debug(`Start load ${fileName}`);
            this.loadStatus[fileName] = "loading";
            const loadResult = await load({
                filePaths: [
                    {
                        src: this.filePath(fileName),
                        id: fileName,
                    },
                ],
            });
            log.debug(`End load ${fileName}`);
            this.waiters[fileName].trigger();
            const element = loadResult[fileName].result;
            await this.callbacks[fileName](element);
            this.loadStatus[fileName] = element;
        }
        log.debug(`All movies for interactions are loaded`);
    }
    filePath(fileName) {
        const skippedVideos = {
            "1번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.first !== "full"
                ? `/resources/전체 영상 파일/1번 영상 단축.mp4`
                : null,
            "2번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.second !== "full"
                ? "/resources/전체 영상 파일/2번 영상 단축.mp4"
                : null,
            "3번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.third !== "full"
                ? "/resources/전체 영상 파일/3번 영상 단축.mp4"
                : null,
            "5번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.fifth !== "full"
                ? "/resources/전체 영상 파일/5번 영상 단축.mp4"
                : null,
            "6번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.sixth !== "full"
                ? "/resources/전체 영상 파일/6번 영상 단축.mp4"
                : null,
            "7번 영상.mp4": FromStartSkipper.getSkip().interactionVideo.seventh !== "full"
                ? "/resources/전체 영상 파일/7번 영상 단축.mp4"
                : null,
        };
        return (skippedVideos[fileName] || toRootPath(`전체 영상 파일/2/${fileName}`));
    }
    async wait(fileName) {
        await this.waiters[fileName].wait();
        return this.loadStatus[fileName];
    }
    clearMovie(fileName) {
        const element = this.loadStatus[fileName];
        if (element.pause != null) {
            element.pause();
            element.removeAttribute("src"); // empty source
            element.load();
        }
        this.loadStatus[fileName] = "used";
    }
    runWhenLoaded(fileName, callback) {
        this.callbacks[fileName] = callback;
        if (this.waiters[fileName].triggered) {
            callback(this.loadStatus[fileName]);
        }
    }
}
function emptyCallbacks() {
    return {
        "1번 영상.mp4": () => {
            return Promise.resolve();
        },
        "2번 영상.mp4": () => {
            return Promise.resolve();
        },
        "3번 영상.mp4": () => {
            return Promise.resolve();
        },
        "5번 영상.mp4": () => {
            return Promise.resolve();
        },
        "6번 영상.mp4": () => {
            return Promise.resolve();
        },
        "7번 영상.mp4": () => {
            return Promise.resolve();
        },
    };
}
function newWaiters() {
    return {
        "1번 영상.mp4": new Waiter(),
        "2번 영상.mp4": new Waiter(),
        "3번 영상.mp4": new Waiter(),
        "5번 영상.mp4": new Waiter(),
        "6번 영상.mp4": new Waiter(),
        "7번 영상.mp4": new Waiter(),
    };
}
//# sourceMappingURL=resources.js.map